import React from "react";
import InputField from "../../forms/input-field";
import ImageField from "../../forms/images-field";

const StoreDrugDlDetailsTab = () => {
  return (
    <div className="w-full 2xl:w-[30%] lg:w-[60%] px-5 xl:px-10">
      <InputField
        // isRequired={true}
        type="date"
        name="dl_valid_upto"
        placeholder="Enter DL Valid Upto"
        label="DL Valid Upto"
        labelWidth="8.5rem"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_no_20_20b"
        placeholder="Enter DL No. 20/20B"
        label="DL No. 20/20B"
        labelWidth="8.5rem"
      />
      <ImageField
        label="Upload DL 20/20B"
        labelWidth="8.5rem"
        name="dl_20_20b_image"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_no_21_21b"
        placeholder="Enter DL No. 21/21B"
        label="DL No. 21/21B"
        labelWidth="8.5rem"
      />
      <ImageField
        label="Upload DL 21/21B"
        labelWidth="8.5rem"
        name="dl_21_21b_image"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_no_21c"
        placeholder="Enter DL No. 21C"
        label="DL No. 21C"
        labelWidth="8.5rem"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_no_21f"
        placeholder="Enter DL No. 21F"
        label="DL No. 21F"
        labelWidth="8.5rem"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_no_name"
        placeholder="Enter DL No. Name"
        label="DL No. Name"
        labelWidth="8.5rem"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_store_sq_ft"
        placeholder="Enter Store Area (Sq ft)"
        label="Store Area (Sq ft)"
        labelWidth="8.5rem"
      />
    </div>
  );
};

export default StoreDrugDlDetailsTab;
